import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import {
  GetSingleRole,
  EditRole,
  CreateRole,
  reset,
} from "../../../features/RoleSlice";

import Swal from "sweetalert2";
import {
  Card,
  Button,
  Form,
  Col,
  Row,
  Modal,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronCircleLeft,
  faPencilAlt,
} from "@fortawesome/free-solid-svg-icons";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

const FormRolePage = () => {
  const [newData, setNewData] = useState({
    kode: "",
    nama: "",
  });

  const dispatch = useDispatch();
  const { data, isLoading, isEdit, isCreate } = useSelector(
    (state) => state.role
  );

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (id) {
      dispatch(GetSingleRole({ id, token }));
    }
    if (isEdit || isCreate) {
      Swal.fire({
        title: "Berhasil",
        showConfirmButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          navigate("/master/role/list");
        }
      });
    }
  }, [id, dispatch, token, isEdit, isCreate, navigate]);

  useEffect(() => {
    setNewData({ kode: data?.data?.id, nama: data?.data?.nama });
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (id) {
      dispatch(EditRole({ id, nama: newData.nama, token }));
    } else {
      dispatch(reset());
      dispatch(CreateRole({ kode: newData.kode, nama: newData.nama, token }));
    }
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[3] === "view" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/${param.pathname.split("/")[1]}/edit/${id}`}
            >
              <FontAwesomeIcon icon={faPencilAlt} className="me-2" />
              Edit
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "add" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/${param.pathname.split("/")[1]}/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "edit" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/${param.pathname.split("/")[1]}/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}
      <ModalLoading isLoading={isLoading} />
      <Card border="light" className="shadow-sm mb-4">
        {param.pathname.split("/")[3] === "view" ? (
          <FormPage
            newData={newData}
            setNewData={setNewData}
            handleSubmit={handleSubmit}
            isLocked={true}
          />
        ) : param.pathname.split("/")[3] === "add" ? (
          <FormPage
            newData={newData}
            setNewData={setNewData}
            handleSubmit={handleSubmit}
          />
        ) : param.pathname.split("/")[3] === "edit" ? (
          <FormPage
            newData={newData}
            setNewData={setNewData}
            handleSubmit={handleSubmit}
          />
        ) : null}
      </Card>
    </AdminLayout>
  );
};

const FormPage = ({
  newData,
  setNewData,
  id,
  isLocked = false,
  handleSubmit,
}) => {
  return (
    <Card.Body>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12} className="mb-3">
            <Form.Group id="kode">
              <Form.Label>Kode</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Kode"
                name="kode"
                disabled={isLocked}
                value={newData.kode || ""}
                onChange={(e) =>
                  setNewData({ ...newData, kode: e.target.value })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="Nama">
              <Form.Label>Nama</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Nama"
                name="nama"
                disabled={isLocked}
                value={newData.nama || ""}
                onChange={(e) =>
                  setNewData({ ...newData, nama: e.target.value })
                }
              />
            </Form.Group>
          </Col>
        </Row>
        <div>
          {!isLocked ? (
            <Button type="submit">{id ? "Update" : "Simpan"}</Button>
          ) : null}
        </div>
      </Form>
    </Card.Body>
  );
};

const ModalLoading = ({ isLoading }) => {
  return (
    <Modal as={Modal.Dialog} centered show={isLoading}>
      <Modal.Body>
        <p>Loading...</p>
      </Modal.Body>
    </Modal>
  );
};

export default FormRolePage;
